export function formatSVGDataURI(svg: string) {
  const encoded = svg
    .replaceAll('<', '%3C')
    .replaceAll('>', '%3E')
    .replaceAll('#', '%23')
  return `data:image/svg+xml;utf8,${encoded}`
}
